import {isInProdEnvFn, isInShowEnvFn} from '@/mm/utils.js'
import { ref } from 'vue'

export const defaultTitle = '瑞诺主题设计平台'

export const baseUrl = 'https://admin-api.uniquecncmach.com'

var isInProdEnv = isInProdEnvFn()
var isInShowEnv = isInShowEnvFn()


export const imgUrl = (()=>{
  if (isInShowEnv) {
    return 'https://manage-admin.show.chukouplus.com'
  }else{
    return !isInProdEnv
      ? 'https://admin.uniquecncmach.com'
      : 'https://www.chukouplus.com'
  }

})()

export const safeList = [
  { label: '1680px', value: 1680 },
  { label: '1600px', value: 1600 },
  { label: '1400px', value: 1400 },
  { label: '1200px', value: 1200 }
]

export const TEXT_REMARK_MAP = new Map([
  [3, '内页模块标题'],
  [4, '详情页标题'],
  [5, '列表标题']
])

export const TEXT_REMARK_OBJECT = Object.fromEntries(TEXT_REMARK_MAP)
